<script>
export default {
    name: "AttributesValidationsMixin",
    methods: {
        isRequiredClassValidation(name) {
            let required = false;
            if (this.itemsValidationsRequired?.length){
                let item = this.itemsValidationsRequired.find(i => i.name === name)
                if (item){
                    required = item.is_required;
                }
            }
           return required;
        },
        requiredClassValidation(name, type = this.clientPublicType) {
            let required = false;
            if (type === 'natural'){
                if (this.attrsPhisical?.length){
                    let item = this.attrsPhisical.find(i => i.name === name)
                    if (item){
                        required = item.is_required;
                    }
                }
            }else if (type === 'legal'){
                if (this.attrsJuridical?.length){
                    let item = this.attrsJuridical.find(i => i.name === name)
                    if (item){
                        required = item.is_required;
                    }
                }
            }
            return required;
        },
    },
}
</script>

<style scoped>

</style>